import React, {
    useState,
    useEffect,
    useRef,
    useLayoutEffect
} from 'react';
import { slick } from "@accessible360/accessible-slick";

import { getCustomer } from "../router";

import * as OPTIONS from "../option-fields";

import AccountNavigation from './account-navigation';
import LogoutButton from '../components/logout-button';
import UpsellBlock from '../components/upsell-block';
import CustomerMemberhips from './customer-memberships';

const above_breakpoint = window.matchMedia("(min-width: 75em)").matches;

// const getMatchingOffersByMembershipIds = (ids) => {
//     const elements = OPTIONS.account.personalised_offers.offers;
//     if (!elements) return;

//     return Array.from(elements).filter(el =>
//       ids.includes(el.getAttribute('personalised-offer'))
//     );
// }

const getMatchingOffersByTagIds = (ids = []) => {
    const elements = OPTIONS.account.personalised_offers?.offers;
    if (!elements || !ids.length) return [];

    const idSet = new Set(ids);

    return Array.from(elements).filter(el => {
    const offerId = el.getAttribute('personalised-offer');
    return offerId && idSet.has(offerId);
    });
}

const AccountMembership = () => {

    const { data: customer } = getCustomer();

    const [personalisedOffers, setPersonalisedOffers] = useState(null);
    const containerRef = useRef(null);

    useEffect(() => {
    if (!customer || !customer.tags?.length) {
        setPersonalisedOffers([]);
        return;
    }

    const tagIds = customer.tags.map(tag => tag.id).filter(Boolean);

    // console.log('Customer tag IDs:', tagIds);
    // console.log('Offer IDs:', Array.from(OPTIONS.account.personalised_offers.offers).map(el => el.getAttribute('personalised-offer')));

    const matchingOffers = getMatchingOffersByTagIds(tagIds);
    setPersonalisedOffers(matchingOffers);
    }, [customer]);

    useEffect(() => {
        const observer = new MutationObserver(() => {
            const buttons = document.querySelectorAll('.card--membership__benefits--button');
            if (!buttons.length) return;

            buttons.forEach(button => {
                // Prevent double-binding
                if (button.dataset.bound === "true") return;

                button.dataset.bound = "true"; // mark as bound
                button.addEventListener('click', () => {
                    const contentId = button.getAttribute('aria-controls');
                    const content = document.getElementById(contentId);

                    if (!content) return;

                    const isExpanded = button.getAttribute('aria-expanded') === 'true';
                    button.setAttribute('aria-expanded', String(!isExpanded));
                    content.hidden = isExpanded;
                    content.setAttribute('aria-hidden', String(isExpanded));
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });

        return () => observer.disconnect();
    }, []);

    useLayoutEffect(() => {
        
        if (!containerRef.current || !above_breakpoint) return;

        // Wait for DOM to render
        const timeout = setTimeout(() => {
            const carousel = containerRef.current.querySelector("[data-carousel]");
            if (!carousel) return;

            if (carousel.classList.contains("slick-initialized")) {
                carousel.slick("refresh");
                return
            }

            const arrow = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22"><path fill-rule="evenodd" d="M10.6 21.3a1 1 0 0 1-1-1V3.4l-7.9 8A1 1 0 0 1 .3 9.8L9.9.3a1 1 0 0 1 1.4 0L21 9.9a1 1 0 0 1-1.5 1.4l-7.9-7.9v16.9c0 .5-.4 1-1 1Z" clip-rule="evenodd"/></svg>`;
            
            const slickProps = {
                dots: false,
                arrows: true,
                infinite: false,
                speed: 300,
                slidesToShow: 2,
                adaptiveHeight: false,
                arrowsPlacement: "afterSlides",
                prevArrow: '<button type="button" data-control-prev><span class="sr-text">Previous</span>' + arrow + "</button>",
                nextArrow: '<button type="button" data-control-next><span class="sr-text">Next</span>' + arrow + "</button>",
            };

            $(carousel).slick(slickProps);
        }, 0);

        return () => clearTimeout(timeout);
    }, [containerRef.current]);

    // console.log('DISCOUNT', OPTIONS.account.discount_event_feed)

    return (
        <>
            <AccountNavigation />

            <div className='booking-pathway__container booking-pathway__account booking-pathway__account--memberships'>

                <div className='booking-pathway__main-content'>
                    <h1 className='booking-pathway__header'>Membership & offers</h1>

                    {customer.subscriptions?.length ?
                        <div className='customer-status-blocks'>
                            <CustomerMemberhips />
                        </div>
                    :OPTIONS.account.membership_upsell.block ?
                        <div class="" dangerouslySetInnerHTML={{__html: OPTIONS.account.membership_upsell.block.innerHTML}}></div>
                    :null
                    }

                    {personalisedOffers?.length ?
                        <div className='personalised-offers'>
                            <h2 className='booking-pathway__header'>Your personalised offers</h2>
                            {personalisedOffers.map((offer, index) =>
                                <div className='personalised-offer' key={index} dangerouslySetInnerHTML={{__html : offer.innerHTML}}></div>
                            )}
                        </div>
                    :null}

                    {OPTIONS.account.discount_event_feed.block ?
                        <div ref={containerRef} className="section discount-event-feed" dangerouslySetInnerHTML={{__html: OPTIONS.account.discount_event_feed.block.innerHTML}}></div>
                    :null}
                </div>

                <div className='booking-pathway__footer'>
                    <LogoutButton />

                    <UpsellBlock content={OPTIONS.account.orders_upsell} type="orders-upsell" />
                </div>

            </div>
        </>
    );
};

export default AccountMembership;
